import * as React from 'react';
import Grid from '@mui/material/Grid';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Translate } from '../../../shared/LanguageService';
import NoCalendarPlaceholder from './components/NoCalendarPlaceholder';
import { getUser } from '../../../reducers/userReducer';
import OrderListSection from './orderList/OrderListSection';
import CalendarSection from './calendar/CalendarSection';
import useSelectedOrder from './state/useSelectedOrder';
import CalendarWithAllPhotographers from './calendar/view/CalendarWithAllPhotographers';

type BookingCalendarLabels = {
    showAllPhotographersButtonLabel: string;
    calendarPlaceholderText: string;
};

type BookingCalendarProps = {
    labels: BookingCalendarLabels;
    showBookingsCalendarFeatureToggle: boolean;
    user: any;
};

const StyledPageGrid = styled(Grid)(({ theme }) => ({
    position: 'fixed',
    top: '100px',
    right: 0,
    left: 0,
    bottom: '1px',
    width: '100%',
    maxWidth: '1900px',
    minWidth: '800px',
    padding: '10px 16px 16px 16px',
    maxHeight: '100%',
    overflow: 'auto',
    margin: 'auto'
}));

function ResetShowAllPhotographerThenRenderCalendarSection({
    resetShowAllPhotographers,
    user,
    selectedOrder,
    availableRegions,
    isAdvancedMode,
    hideTravelTimes,
    handleHideTravelTime,
    onChangeAdvancedMode
}) {
    resetShowAllPhotographers();

    return (
        <CalendarSection
            user={user}
            selectedOrder={selectedOrder}
            availableRegions={availableRegions}
            isAdvancedMode={isAdvancedMode}
            onChangeAdvancedMode={onChangeAdvancedMode}
            hideTravelTimes={hideTravelTimes}
            handleHideTravelTime={handleHideTravelTime}
        />
    );
}

export const BookingsCalendar = connect((state) => ({
    user: getUser(state)
}))(
    withRouter(({ labels, user }: BookingCalendarProps & RouteComponentProps) => {
        const {
            selectedOrder,
            handleSelectedOrder,
            handleChangeAdvancedMode,
            availableRegions,
            isAdvancedMode,
            hideTravelTimes,
            handleHideTravelTime
        } = useSelectedOrder();

        let [showAllPhotographers, setShowAllPhotographers] = React.useState(false);

        return (
            <StyledPageGrid container spacing={2}>
                <OrderListSection user={user} onSelectOrder={handleSelectedOrder} />
                {selectedOrder ? (
                    <ResetShowAllPhotographerThenRenderCalendarSection
                        resetShowAllPhotographers={() => {
                            setShowAllPhotographers(false);
                        }}
                        user={user}
                        selectedOrder={selectedOrder}
                        availableRegions={availableRegions}
                        isAdvancedMode={isAdvancedMode}
                        hideTravelTimes={hideTravelTimes}
                        handleHideTravelTime={handleHideTravelTime}
                        onChangeAdvancedMode={handleChangeAdvancedMode}
                    />
                ) : showAllPhotographers ? (
                    <CalendarWithAllPhotographers user={user} />
                ) : (
                    <NoCalendarPlaceholder
                        label={labels.calendarPlaceholderText}
                        showAllPhotographersButtonLabel={labels.showAllPhotographersButtonLabel}
                        onChangeShowAllPhotographers={() => {
                            setShowAllPhotographers(true);
                        }}
                    />
                )}
            </StyledPageGrid>
        );
    })
);

const BookingCalendarTranslationLayer = (props): any => {
    let labels: BookingCalendarLabels = {
        calendarPlaceholderText: Translate(
            'orders/list/bookings-calendar/calendar-placeholder-text'
        ),
        showAllPhotographersButtonLabel: Translate(
            'orders/list/bookings-calendar/show-all-photographers-button-label'
        )
    };
    return <BookingsCalendar {...props} labels={labels} />;
};

export default BookingCalendarTranslationLayer;
